module.exports = __webpack_public_path__ + "fonts/playfair-display-v22-latin-700.6c63342c.woff2";